<template>
	<div class="field" :class="{ 'field--error': error }">
		<label class="label">{{ label }}</label>
		<div class="control">
			<slot></slot>
			<p v-if="!required && label" class="help is-danger" :data-test="testName">
				{{ label }} is required
			</p>
		</div>
	</div>
</template>

<script>
export default {
	name: "FormField",
	props: {
		error: {
			type: Boolean,
			default: () => false
		},
		required: {
			type: Boolean,
			default: () => false
		},
		label: {
			type: String,
			default: () => null
		}
	},
	computed: {
		testName() {
			return `${this.label} error`.split(" ").join("-").toLowerCase();
		}
	}
};
</script>

<style lang="scss" scoped>
.field {
	.help {
		display: none;
		font-size: (14px / 16px) * 1rem;
	}

	&--error {
		.help {
			display: inline-block;
		}

		.select + .help {
			display: block;
		}
	}
}
</style>
